module.exports = __webpack_public_path__ + "static/media/Avatar3.1f508a6c.svg";